(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["saptvaar-cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-change]');
    if (!button) return;

    const quantity = button.parentElement.querySelector('input[type="number"]');
    if (!quantity) return;

    if (button.dataset.cartQuantityChange === '1') {
      quantity.stepUp();
    } else {
      quantity.stepDown();
    }

    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saptvaar-collection-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseRails = (root = document) => {
      root.querySelectorAll('[data-sv-rail-section]').forEach((section) => {
        if (section.dataset.railReady === 'true') return;
        section.dataset.railReady = 'true';
        const rail = section.querySelector('[data-sv-rail]');
        const previous = section.querySelector('[data-sv-rail-previous]');
        const next = section.querySelector('[data-sv-rail-next]');
        if (!rail) return;
        const distance = () => Math.max(rail.clientWidth * .82, 280);
        previous?.addEventListener('click', () => rail.scrollBy({ left: -distance(), behavior: 'smooth' }));
        next?.addEventListener('click', () => rail.scrollBy({ left: distance(), behavior: 'smooth' }));
        rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') rail.scrollBy({ left: -distance(), behavior: 'smooth' });
          if (event.key === 'ArrowRight') rail.scrollBy({ left: distance(), behavior: 'smooth' });
        });
      });
    };
    initialiseRails();
    document.addEventListener('shopify:section:load', (event) => initialiseRails(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saptvaar-first-wear-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseFirstWear = (root = document) => {
      root.querySelectorAll('[data-first-wear-strip]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';
        const now = Date.now();
        const windows = [...section.querySelectorAll('[data-first-wear-window]')]
          .filter((item) => new Date(item.dataset.end).getTime() > now)
          .sort((a, b) => new Date(a.dataset.start) - new Date(b.dataset.start))
          .slice(0, 3);
        windows.forEach((item) => item.hidden = false);
        const empty = section.querySelector('[data-first-wear-empty]');
        if (empty) empty.hidden = windows.length > 0;
      });
    };
    initialiseFirstWear();
    document.addEventListener('shopify:section:load', (event) => initialiseFirstWear(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
